/** WhatsApp number in international format without +, spaces, or leading 0 (e.g. 40722123456) */
export const WHATSAPP_PHONE = "40757162237";
